module.exports = __webpack_public_path__ + "img/interior_17.8b242ab7.jpg";